import { render, staticRenderFns } from "./FinalInvoiceFromExperimentalReportViewer.vue?vue&type=template&id=260858c7&"
import script from "./FinalInvoiceFromExperimentalReportViewer.vue?vue&type=script&lang=ts&"
export * from "./FinalInvoiceFromExperimentalReportViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
